import { alpha, styled } from '@mui/material/styles';

import Button from 'components/button';

export const SessionTimeoutBackdrop = styled('div')(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  zIndex: theme.zIndex.modal,
  backgroundColor: alpha(theme.palette.common.black, 0.45),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));

export const SessionTimeoutPanel = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '480px',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(3),
}));

export const SessionTimeoutTitle = styled('h2')(({ theme }) => ({
  margin: 0,
  ...theme.typography.h6,
  color: theme.palette.text.primary,
  fontWeight: 600,
}));

export const SessionTimeoutBody = styled('p')(({ theme }) => ({
  margin: theme.spacing(2, 0, 0),
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  whiteSpace: 'pre-line',
}));

export const SessionTimeoutActions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(3),
}));

const actionButtonBase = {
  '&&': {
    flex: 1,
    minHeight: '38px',
    height: '38px',
  },
};

export const SessionTimeoutContinueButton = styled(Button)(() => actionButtonBase);
export const SessionTimeoutLogoutButton = styled(Button)(() => actionButtonBase);
